import { FcNext } from 'react-icons/fc';
import { BiBuildings } from 'react-icons/bi';
import { BsTrash } from 'react-icons/bs';
import { FiMapPin } from 'react-icons/fi';
import './LastSearchesList.css';

const LastSearchesList = ({ lastSearches, cityChangeHandler, cityRemoveHandler }) => (
    <div className="last-searches__items">
        <div className="last-searches__title">Últimas búsquedas</div>

        {lastSearches.length === 0 
        && <div className="last-searches__empty-msg">No hay ninguna búsqueda guardada</div>}

        {lastSearches.map((city, index) => {
            if (index >= 10) return null;

            return (
                <button className="last-searches__item" key={city.name} onClick={() => cityChangeHandler(city)}>
                    <div className="last-searches__column-left">
                        <div className="last-searches__icon">
                            {city.map 
                            ? <FiMapPin data-testid="last-searches__icon--pin" /> 
                            : <BiBuildings data-testid="last-searches__icon--building" />}
                        </div>
                        <div className="last-searches__location">
                            <div className="last-searches__city">{city.name}</div> 
                            <div className="last-searches__province">{city.province}</div>
                        </div>
                    </div>
                    <div className="last-searches__icons">
                        <div className="last-searches__icon last-searches__arrow"><FcNext /></div>
                        <div className="last-searches__icon last-searches__trash" onClick={(e) => cityRemoveHandler(e, city)} >
                            <BsTrash data-testid="last-searches__icon--trash" />
                        </div>
                    </div>
                </button>
            )
        })}
    </div>
)

export default LastSearchesList;
